import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import { AuthProvider } from "@/lib/auth";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Homeowners from "@/pages/Homeowners";
import Commercial from "@/pages/Commercial";
import Pricing from "@/pages/Pricing";
import Emergency from "@/pages/Emergency";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminTemplates from "@/pages/admin/AdminTemplates";

function PublicSite() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/homeowners" element={<Homeowners />} />
        <Route path="/commercial" element={<Commercial />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/emergency" element={<Emergency />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Admin (no public Layout) */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Navigate to="leads" replace />} />
              <Route path="leads" element={<AdminLeads />} />
              <Route path="settings" element={<AdminSettings />} />
              <Route path="templates" element={<AdminTemplates />} />
            </Route>

            {/* Public site (everything else uses the marketing Layout) */}
            <Route path="/*" element={<PublicSite />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster richColors position="bottom-right" />
    </div>
  );
}

export default App;
